module.exports = __webpack_public_path__ + "23ecc5b7864907a7449f8cfd54a1df13.pdf";